let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k8xPd")).then(() => parcelRequire('iB9F0'));